import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class NoScrollService {
    private stack: number[] = [];
    private uid = 0;

    private releaseListener?: () => void;
    constructor(@Inject(DOCUMENT) private document: Document) {}

    block() {
        this.disableScroll();
        const uid = this.uid++;
        this.stack.push(uid);
        return () => {
            const index = this.stack.indexOf(uid);
            this.stack.splice(index, 1);
            if (!this.stack.length) {
                this.restoreScroll();
            }
        };
    }

    private disableScroll() {
        if (!this.releaseListener) {
            const preventScroll = (event: Event) => {
                event.preventDefault();
            };
            this.document.body.addEventListener('touchmove', preventScroll, { passive: false });
            this.releaseListener = () => document.body.removeEventListener('touchmove', preventScroll);
        }
    }
    private restoreScroll() {
        if (this.releaseListener) {
            this.releaseListener();
            this.releaseListener = undefined;
        }
    }
}
